export default {
  left: {
    group: '我的分组: ',
    location: '日程地点: ',
    description: '日程说明: ',
    scoreChart: '评分表: ',
    scoreChartDescription: '评分表说明: ',
  },
  logout: '退出登录',
  right: {
    title: '任务列表',
    incomplete: '未完成{number}人',
    complete: '已完成{number}人',
    signature: '离场确认', // 原评分签字
    searchPlaceholder: '名称',
    mobileTitle: '任务：未完成{incomplete}人   已完成{complete}人',
  },
  table: {
    operation: '操作',
    status: '状态',
    name: '名称',
    number: '人数',
    called: '叫号',
    incomplete: '未完成',
    time: '面试时间',
    people: '{number}人',
    preparation: '准备入场',
    tips: '已提示',
    revert: '撤销',
    view: '查看',
    signature: '评分签字',
    signed: '已签字',
    viewDetail: '查看详情',
    preview: '结果预览',
  },
  nodata: '暂无任务',
  toEntriesMsg: '面试已结束打分',
  401: '登录过期，请重新登录',
  status: {
    waiting: '未开始',
    interviewing: '进行中',
    complete: '已结束',
    default: '出错了',
  },
  signOut: {
    msg: '确定退出面试评分系统？',
    cancel: '取消退出',
  },
  leaveDialog: {
    title: '提示',
    message: '您已完成所有评分，是否确认离场？',
    cancel: '取消',
    confirm: '离场',
    alreadyLeft: '您已离场',
  },
};
